// extracted by mini-css-extract-plugin
export default {"buttonOption":"ButtonOption_buttonOption__0iT4C","width":"ButtonOption_width__3w81O"};